'use client';

import { useEffect } from 'react';
import { useTranslations } from 'next-intl';
import { reportErrorToHyperDX } from '@/lib/telemetry/hyperdx';
import { addBreadcrumb } from '@/lib/telemetry/breadcrumbs';

export default function LocaleError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useTranslations('common');

  useEffect(() => {
    addBreadcrumb('error', error.message, { digest: error.digest });
    reportErrorToHyperDX(error, { digest: error.digest, boundary: 'locale' });
    console.error(error);
  }, [error]);

  return (
    <div className="flex min-h-[40vh] flex-col items-center justify-center gap-4 p-8">
      <h2 className="text-lg font-semibold text-gray-900">
        {t('errorOccurred')}
      </h2>
      <p className="max-w-md text-center text-sm text-gray-600">
        {error.message}
      </p>
      <button
        type="button"
        onClick={reset}
        className="rounded-lg px-4 py-2 text-sm font-medium text-white"
        style={{ backgroundColor: '#e96847' }}
      >
        {t('retry')}
      </button>
    </div>
  );
}
